var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],ref:"share",staticStyle:{"height":"300px","margin":"0 auto"},attrs:{"id":"bingli"}})}
var staticRenderFns = []

export { render, staticRenderFns }